"use client";
import { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpFromSquare } from "@fortawesome/pro-regular-svg-icons";
import { motion, AnimatePresence } from "framer-motion";
import { Article } from "@/entities";

interface PostShareButtonProps {
  article: Article;
}
export default function PostShareButton({ article }: PostShareButtonProps) {
  const [open, setOpen] = useState(false);

  const dropdownRef = useRef<HTMLDivElement>(null);
  const handleCopyUrl = () => {
    navigator.clipboard.writeText(window.location.href);
    alert("URL이 복사되었습니다!");
    setOpen(false);
  };

  const handleShareKakao = () => {
    window.Kakao.Share.sendScrap({
      requestUrl:
        `${window.location.origin}/app/article/${article.id}` as string,
    } as any);
    setOpen(false);
  };

  const handleShareX = () => {
    const url = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
      window.location.href
    )}`;
    window.open(url, "_blank");
    setOpen(false);
  };

  const handleFacebook = () => {
    const url = `https://www.facebook.com/sharer.php?u=${encodeURIComponent(
      window.location.href
    )}`;
    window.open(url, "_blank");
    setOpen(false);
  };
  const shareOptions = [
    { label: "URL 복사", onClick: handleCopyUrl },
    { label: "카카오톡", onClick: handleShareKakao },
    { label: "트위터", onClick: handleShareX },
    { label: "페이스북", onClick: handleFacebook },
  ];
  // 바깥 클릭 시 닫기
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <div className="relative inline-block" ref={dropdownRef}>
      <button
        onClick={() => setOpen((prev) => !prev)}
        className="group flex items-center px-3 md:py-3 py-2.5 rounded-full bg-white border border-softGray-10 
        transition-all duration-300 ease-out group-hover:px-4
         "
      >
        <FontAwesomeIcon
          icon={faArrowUpFromSquare}
          className="text-midGray-20 transition-colors duration-300 group-hover:text-black ml-1 md:text-base text-sm"
        />
        <span
          className=" text-sm md:text-lg mx-2 text-midGray-50 transition-colors duration-300 group-hover:text-black-300 tracking-tight"
          style={{ fontFamily: '"paperlogy-Medium", sans-serif' }}
        >
          공유하기
        </span>
      </button>

      {/* 드롭다운 */}
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2, ease: "easeOut" }}
            className="absolute mt-4 right-0 w-48 bg-white border border-light-60 rounded-2xl shadow-lg 
                       overflow-hidden z-50"
          >
            <ul className="flex flex-col">
              {shareOptions.map((option, index) => (
                <li
                  key={index}
                  className="md:text-base text-[15px] px-5 py-5 hover:bg-gray-50 tracking-tight cursor-pointer text-midGray-50"
                  onClick={option.onClick}
                  style={{ fontFamily: '"paperlogy-Medium", sans-serif' }}
                >
                  {option.label}
                </li>
              ))}
            </ul>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
